import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import MaterialTable from "material-table";
import moment from "moment";
import { Button, Typography } from "@material-ui/core";
import FormCctv from "./FormCctv";
import Modal from "./ModalCctv";
import { deleteCctv, getCctv } from "../../../../services";

const LiveCctv = () => {
  const tableRef: any = React.createRef();
  const { enqueueSnackbar } = useSnackbar();
  const [modalState, setModalState] = useState({
    open: false,
    title: "",
    content: <div />,
  });
  const [refreshTableState, setRefreshTableState] = useState(0);

  const handleOpenModal = (title: string, content: any) => {
    setModalState({
      open: true,
      title,
      content,
    });
  };

  const handleCloseModal = () => {
    setModalState({
      ...modalState,
      open: false,
    });
  };

  const refreshTable = () =>
    tableRef.current && tableRef.current.onQueryChange();

  const handleRefreshTable = () => setRefreshTableState(refreshTableState + 1);

  const handleDeleteUser = async (id: number) => {
    try {
      const res = await deleteCctv(id);
      if (res.status === "success") {
        handleCloseModal();
        handleRefreshTable();
      }
      enqueueSnackbar(res.message, { variant: res.status });
    } catch (err: any) {
      enqueueSnackbar(err.message, { variant: "error" });
    }
  };

  useEffect(() => {
    refreshTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTableState]);

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          handleOpenModal(
            "ADD CCTV",
            <FormCctv
              action="add"
              onCancel={handleCloseModal}
              refreshTable={handleRefreshTable}
            />
          )
        }
        style={{ marginBottom: 16 }}
      >
        Add CCTV
      </Button>
      <MaterialTable
        title="List Cctv"
        tableRef={tableRef}
        columns={[
          {
            title: "ID",
            field: "id",
            width: 10,
            sorting: false,
          },
          {
            title: "Name",
            field: "name",
            sorting: false,
          },
          {
            title: "Description",
            field: "description",
            sorting: false,
          },
          {
            title: "createdAt",
            field: "created_at",
            sorting: false,
            render: ({ created_at: createdAt }) =>
              moment(createdAt).format("YYYY-MM-DD HH:mm:ss"),
          },
        ]}
        data={(query) =>
          new Promise((resolve) => {
            getCctv(query.pageSize, query.page + 1, query.search).then(
              ({ data, status, message }) => {
                if (status === "success") {
                  resolve({
                    data: data.rows,
                    page: data.page - 1,
                    totalCount: data.total,
                  });
                } else {
                  enqueueSnackbar(message, { variant: "error" });
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                }
              }
            );
          })
        }
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 25, 50],
          actionsColumnIndex: -1,
        }}
        actions={[
          {
            icon: "edit",
            tooltip: "Edit Cctv",
            onClick: (event: any, rowData: any) => {
              handleOpenModal(
                "EDIT CCTV",
                <FormCctv
                  action="edit"
                  onCancel={handleCloseModal}
                  refreshTable={handleRefreshTable}
                  data={rowData}
                />
              );
            },
          },
          {
            icon: "delete",
            tooltip: "Delete Cctv",
            onClick: (event, rowData) => {
              handleOpenModal(
                "Delete cctv",
                <>
                  <Typography>
                    Are you sure to delete cctv id {rowData.id} ?
                  </Typography>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 32,
                      marginBottom: 16,
                      display: "flex",
                      gap: 16,
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button variant="contained" onClick={handleCloseModal}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleDeleteUser(rowData.id)}
                    >
                      Delete
                    </Button>
                  </div>
                </>
              );
            },
          },
        ]}
      />
      <Modal
        title={modalState.title}
        content={modalState.content}
        open={modalState.open}
        handleClose={handleCloseModal}
        hasDialogAction={false}
        maxWidth="xs"
        textButtonOk="Ok"
      />
    </div>
  );
};

export default LiveCctv;
